import { TaxReturnChangeComponent } from '@dec/shared';

import { type TaxReturnRequest } from '../models/types';
import { useGetFormConnection, useGetGlobalTaxReturnValues } from '../services/signalr.hooks';
import { useFormLogRulesStore } from '../stores/useFormLogRulesStore';

export const ChangeComponent = ({ value }: { value: any }) => {
  const connection = useGetFormConnection();
  const addLogRule = useFormLogRulesStore((state) => state.addLogRule);
  const runtime = useGetGlobalTaxReturnValues();

  return (
    <TaxReturnChangeComponent<TaxReturnRequest>
      value={value}
      connection={connection}
      runtime={runtime}
      addLogRule={addLogRule}
    />
  );
};
